import React from 'react';

const SocialLinks = React.memo(() => (
  <div className="SocialLinks flex relative">
    <div className="SocialLinks__link SocialLinks__link--facebook mr1">
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${
          window.location.href
        }`}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/icon-facebook.svg`}
          alt="Share on Facebook"
        />
      </a>
    </div>
    <div className="SocialLinks__link SocialLinks__link--twitter mr1">
      <a href={`https://twitter.com/share?url=${window.location.href}`}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/icon-twitter.svg`}
          alt="Share on Twitter"
        />
      </a>
    </div>
    <div className="SocialLinks__link SocialLinks__link--email mr1">
      <a href={`mailto:?to=&body=${window.location.href}`}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/icon-email.svg`}
          alt="Share on Email"
        />
      </a>
    </div>
  </div>
));

export default SocialLinks;
